import { z } from "zod";
import { FontSizeTokenData } from "./font-size";
import { FontFamilyTokenData } from "./font-family";
import { FontWeightTokenData } from "./font-weight";
import { TextDecorationTokenData } from "./text-decoration";
import { TextCaseTokenData } from "./text-case";
import { LetterSpacingTokenData } from "./letter-spacing";
import { LineHeightTokenData } from "./line-height";
import { ParagraphIndentTokenData } from "./paragraph-indent";
import { ParagraphSpacingTokenData } from "./paragraph-spacing";
import { tokenAliasOrValue } from "./base";

export const TypographyValue = z.object({
  fontSize: FontSizeTokenData,
  fontFamily: FontFamilyTokenData,
  fontWeight: FontWeightTokenData,
  textDecoration: TextDecorationTokenData,
  textCase: TextCaseTokenData,
  letterSpacing: LetterSpacingTokenData.optional(),
  lineHeight: LineHeightTokenData.optional(),
  paragraphIndent: ParagraphIndentTokenData.optional(),
  paragraphSpacing: ParagraphSpacingTokenData.optional(),
});

export const TypographyTokenData = tokenAliasOrValue(TypographyValue);

export type TypographyValue = z.infer<typeof TypographyValue>;
export type TypographyTokenData = z.infer<typeof TypographyTokenData>;
